export const VICTORY_MESSAGES = [
    "Splash! That was the last ship.",
    "Fleet gone. Ocean secured.",
    "You just cleared the sea. Nicely done.",
    "Boom! That was the final hit.",
    "All ships sunk. That felt good.",
    "Victory! The ocean approves.",
    "You turned their fleet into driftwood.",
    "Game over… for them 😎",
    "Clean sweep. Impressive.",
    "That was a masterclass in naval combat.",
    "Every ship found. Every ship sunk.",
    "You didn’t miss much, did you?",
    "The sea is calm… because you won.",
    "Target practice complete.",
    "Well played. That was brutal (in a good way)."
];

export const DEFEAT_MESSAGES = [
    "Well… that didn’t go as planned.",
    "Your fleet is now… part of the reef.",
    "Oops. All ships gone.",
    "That escalated quickly.",
    "Defeat! The ocean was not on your side.",
    "Better luck next time, captain.",
    "Your ships took an early retirement.",
    "That was… unfortunate.",
    "The sea claimed your fleet.",
    "Next round? You’ve got this.",
    "Mission failed. Try a different strategy.",
    "They found you first. Every time.",
    "That one hurt. Not gonna lie.",
    "You fought bravely. The ships… not so much.",
    "Time to rebuild the fleet."
];